import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function BeyinYasiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['beyin-yasi-testi']} />;
}
